import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type EmbedRuntime = {
  apiBase?: string
  token?: string
}

function getEmbedRuntime(): EmbedRuntime | undefined {
  if (typeof window === 'undefined') return undefined
  return (window as any).__TOTEMIUM_EMBED__
}

export function getApiBase() {
  const embed = getEmbedRuntime()
  if (embed?.apiBase) return embed.apiBase
  // Nginx will proxy /api/* to FastAPI
  return '/api'
}

export function getToken(): string | null {
  const embed = getEmbedRuntime()
  if (embed?.token) return embed.token
  try {
    return localStorage.getItem('access_token')
  } catch {
    return null
  }
}

export function setTokens(access: string, refresh?: string | null) {
  try {
    localStorage.setItem('access_token', access)
    if (refresh) localStorage.setItem('refresh_token', refresh)
  } catch {
    // Ignore storage errors in environments without localStorage access
  }
}

export function clearTokens() {
  try {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
  } catch {
    // ignore
  }
}

export function setThemeClass() {
  let pref = 'auto'
  try {
    pref = localStorage.getItem('theme') || 'auto'
  } catch {
    pref = 'auto'
  }
  const root = document.documentElement
  const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
  const enableDark = pref === 'dark' || (pref === 'auto' && prefersDark)
  root.classList.toggle('dark', enableDark)
}
